<script lang="ts">
  import Flash from '#app/lib/components/flash.svelte'
  import type { FlashState } from '#app/lib/components/flash.svelte'
  import { assertError } from '#app/lib/error'
  import { icon } from '#app/lib/icons'
  import { reqres } from '#app/radio'
  import Spinner from '#components/spinner.svelte'
  import { serializeGroup, type SerializedGroup } from '#groups/lib/groups'
  import { groupAction, type GroupMembershipAction } from '#groups/lib/groups_data'
  import { I18n } from '#user/lib/i18n'

  let {
    group = $bindable(),
  }: {
    group: SerializedGroup
  } = $props()

  const { _id: groupId, pathname, open } = group

  let flash: FlashState | undefined = $state()
  let waitForUpdatedGroup: Promise<SerializedGroup> | undefined = $state()

  const processing: Record<string, boolean> = $state({})
  async function action (actionName: GroupMembershipAction) {
    try {
      if (reqres.request('require:loggedIn', pathname)) {
        processing[actionName] = true
        waitForUpdatedGroup = groupAction({ action: actionName, groupId })
        const updatedGroup = await waitForUpdatedGroup
        group = serializeGroup(updatedGroup)
      }
    } catch (err) {
      assertError(err)
      flash = err
    } finally {
      processing[actionName] = false
    }
  }
</script>

<div class="actions">
  {#await waitForUpdatedGroup}
    <Spinner center={true} />
  {:then}
    {#if group.mainUserStatus === 'invited'}
      <button class="tiny-button success" onclick={() => action('accept')} disabled={processing.accept || processing.decline}>
        {I18n('accept invitation')}
        {#if processing.accept}<Spinner />{/if}
      </button>
      <button class="tiny-button grey" onclick={() => action('decline')} disabled={processing.accept || processing.decline}>
        {I18n('decline')}
        {#if processing.decline}<Spinner />{/if}
      </button>
    {:else if group.mainUserStatus === 'requested'}
      <div>
        <p class="requested">
          {I18n('your request to join is waiting for approval')}
        </p>
        <button class="tiny-button grey" onclick={() => action('cancel-request')} disabled={processing['cancel-request']}>
          {I18n('cancel request')}
          {#if processing['cancel-request']}<Spinner />{/if}
        </button>
      </div>
    {:else if group.mainUserStatus === 'none'}
      <button class="tiny-button light-blue" onclick={() => action('request')} disabled={processing.request}>
        {#if open}
          {I18n('join group')}
        {:else}
          {I18n('request to join group')}
        {/if}
        {#if processing.request}<Spinner />{/if}
      </button>
    {/if}
  {/await}
</div>
{#if !group.mainUserIsMember}
  <p class="restrictions">
    {@html icon('globe')} {I18n("as you are not a member of the group, you can only see members' public books")}
  </p>
{/if}

<Flash state={flash} />

<style lang="scss">
  @import "general/scss/utils";
  .actions{
    @include display-flex(row);
    font-weight: normal;
    text-align: center;
    // Prevent jump when displaying the spinner
    min-height: 4em;
  }
  button{
    margin: 0 0.5em;
  }
  .requested{
    color: $dark-grey;
  }
  .restrictions{
    text-align: center;
    @include radius;
    @include tiny-button-padding;
    background-color: grey;
    color: white;
    margin: 0 0 0.5em;
  }
  /* Small screens */
  @media screen and (width < $small-screen){
    button{
      margin: 0;
    }
    .restrictions{
      margin: 0.5em;
    }
  }
</style>
